import React from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const FleetTab = ({ fleet, onCreateModal, onEditModal, onDelete }) => (
  <div data-testid="fleet-tab">
    <div className="flex justify-between items-center mb-6">
      <p className="text-s-text2">{fleet.length} vehicles</p>
      <Button onClick={() => onCreateModal('fleet')} className="bg-s-primary hover:bg-s-primary-h text-white" data-testid="add-vehicle-btn">
        <Plus className="w-4 h-4 mr-2" /> Add Vehicle
      </Button>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {fleet.map((vehicle) => (
        <Card key={vehicle.id} className="bg-s-bg2 border-s-border overflow-hidden" data-testid={`fleet-card-${vehicle.id}`}>
          <img src={vehicle.image} alt={vehicle.name} className="w-full h-40 object-cover" />
          <CardContent className="p-4">
            <Badge className={vehicle.available ? 'bg-s-primary/20 text-s-primary' : 'bg-s-primary/20 text-s-primary'}>
              {vehicle.available ? 'Available' : 'Unavailable'}
            </Badge>
            <h3 className="text-s-text font-semibold mt-2">{vehicle.name}</h3>
            <p className="text-s-text2 text-sm">{vehicle.type} &bull; {vehicle.capacity}</p>
            <div className="flex gap-2 mt-4">
              <Button size="sm" variant="outline" onClick={() => onEditModal('fleet', vehicle)} className="flex-1 border-s-border text-s-text2" data-testid={`edit-fleet-${vehicle.id}`}>
                <Pencil className="w-4 h-4 mr-1" /> Edit
              </Button>
              <Button size="sm" variant="outline" onClick={() => onDelete('fleet', vehicle.id)} className="border-red-500/50 text-s-primary hover:bg-s-primary/20" data-testid={`delete-fleet-${vehicle.id}`}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default FleetTab;
